/**
 * Animatie slide down
 * @param {HTMLElement} elm Element de animat
 * @returns {undefined}
 */
export const slideDown = (elm) => {
	if (!elm) {
		return;
	}

	elm.hidden = false;
	elm.style.removeProperty('height');

	const height = `${elm.scrollHeight}px`;

	requestAnimationFrame(() => {
		elm.style.height = height;
	});

	elm.addEventListener('transitionend', function handler(e) {
		if (e.propertyName !== 'height') {
			return;
		}
		elm.removeEventListener('transitionend', handler);
		elm.classList.add('slide-down');
	});
};

/**
 * Animatie slide up
 * @param {HTMLElement} elm Element de animat
 * @returns {undefined}
 */
export const slideUp = (elm) => {
	if (!elm || elm.hidden) {
		return;
	}

	elm.classList.remove('slide-down');

	elm.addEventListener('transitionend', function opacityHandler(e) {
		if (e.propertyName !== 'opacity') {
			return;
		}
		elm.removeEventListener('transitionend', opacityHandler);
		elm.style.height = '0px';
		elm.addEventListener('transitionend', function heightHandler(e) {
			if (e.propertyName !== 'height') {
				return;
			}
			elm.removeEventListener('transitionend', heightHandler);
			elm.hidden = true;
		});
	});
};
